import axios, { AxiosResponse } from "axios"
import { ChatByIdRequest } from "../models/api/ChatByIdRequest"
import { ChatByIdResponse } from "../models/api/ChatByIdResponse"
import { ChatsRequest } from "../models/api/ChatsRequest"
import { AuthRequest } from "../models/api/NetworkRequest"
import { RegisterRequest } from "../models/api/RegisterRequest"
import { SendVNoteResp } from "../models/api/SendVNoteResp"
import { UserChatItem } from "../models/api/UserChatItem"
import { PublicUser, User } from "../models/Users"
import { VChatRequest } from "../models/api/VChatRequest"
import { VNoteRequest } from "../models/api/vNote"
import { LoginResponse } from "../types/LoginResponse"
import { RegisterResponse } from "../models/api/RegisterResponse"
import { LoginRequest } from "../models/api/LoginRequest"
import { MyProfileRequest } from "../models/api/MyProfileRequest"
import { MyProfileResponse } from "../models/api/MyProfileResponse"
import { MyProfileUpdateRequest } from "../models/api/MyProfileUpdateRequest"
import { CreateInviteRequest } from "../models/api/CreateInviteRequest"
import { CreateInviteResponse } from "../models/api/CreateInviteResponse"
import { rootStore } from "../StApp"
import { DeleteProfileRequest } from "../models/api/DeleteProfileRequest"
import { UpdateVIntroVisitRequest } from "../models/api/UpdateVIntroVisitRequest"
import { UpdateGeolocationRequest } from "../models/api/UpdateGeolocationRequest"
import { FetchDateQueueRequest } from "../models/api/FetchDateQueueRequest"
import { FetchDateQueueResponse } from "../models/api/FetchDateQueueResponse"
import { RegisterLikeAndUnlikeRequest } from "../models/api/RegisterLikeAndUnlikeRequest"
import { RegisterLikeAndUnlikeResponse } from "../models/api/RegisterLikeAndUnlikeResponse"
import { RegisterMatchRequest } from "../models/api/RegisterMatchRequest"
import { RegisterDumpRequest } from "../models/api/RegisterDumpRequest"
import { FetchPotMatchesRequest } from "../models/api/FetchPotMatchesRequest"
import { FetchPotMatchesResp } from "../models/api/FetchPotMatchesResp"
import { FetchMatchesRequest } from "../models/api/FetchNewMatchesRequest"
import { FetchMatchesResponse } from "../models/api/FetchNewMatchesResponse"
import { FetchConvMatchesRequest } from "../models/api/FetchConvMatchesRequest"
import { FetchConvMatchesResponse } from "../models/api/FetchConvMatchesResponse"
import { RegisterMatchResponse } from "../models/api/RegisterMatchResponse"
import { LikeOrDumpRequest } from "../models/api/LikeOrDumpRequest"
import { LikeOrDumpResponse } from "../models/api/LikeOrDumpResponse"
import { UpdateFcmTokenRequest } from "../models/api/UpdateFcmTokenRequest"
import { StartHelloRequest } from "../models/api/StartHelloRequest"
import { FetchPubKeyRequest } from "../models/api/FetchPubKeyRequest"
import { FetchPubKeyResponse } from "../models/api/FetchPubKeyResponse"
import { OfflineAnonMsg, OfflineMsg } from "../models/api/OfflineMsg"
import { BlockUserRequest } from "../models/api/BlockUserRequest"
import { FedLoginRequest } from "../models/api/FedLoginRequest"
import { UpdateFedEmailRequest } from "../models/api/UpdateFedEmailRequest"
import { UpdateFedEmailResponse } from "../models/api/UpdateFedEmailResponse"
import { GetDumpListRequest } from "../models/api/GetDumpListRequest"
import { GetDumpListResponse } from "../models/api/GetDumpListResponse"
import { UpdateDumpsRequest } from "../models/api/UpdateDumpsRequest"
import { UpdateDumpsResponse } from "../models/api/UpdateDumpsResponse"
import { FetchMatchUserDetailsResponse } from "../models/api/FetchMatchUserDetailsResponse"
import { CheckInviteRequest } from "../models/api/CheckInviteRequest"
import { CheckInviteResponse } from "../models/api/CheckInviteResponse"

const baseUrl = 'https://75300805.eu-gb.apigw.appdomain.cloud'
const api = axios.create({ baseURL: baseUrl })

class ApiService {

    registerUser(data: RegisterRequest) {

        return api.post<any, AxiosResponse<RegisterResponse>>('/base/register', data)

    }

    loginUser(data: LoginRequest) {

        return api.post<any, AxiosResponse<LoginResponse>>('/base/login', data)

    }

    getUser(data: { userName: string }) {

        return api.post<any, AxiosResponse<PublicUser>>('/base/getUser', data)

    }

    sendVNoteToUser(data: AuthRequest<VNoteRequest>) {

        return api.post<any, AxiosResponse<SendVNoteResp>>('/base/sendVNote', data)

    }

    getAllChats(data: AuthRequest<ChatsRequest>) {

        return api.post<any, AxiosResponse<UserChatItem[]>>('/base/getChats', data)
    }

    getChatById(data: AuthRequest<ChatByIdRequest>) {

        return api.post<any, AxiosResponse<ChatByIdResponse>>('/base/getChatById', data)

    }

    sendVChat(data: AuthRequest<VChatRequest>) {

        return api.post<any, AxiosResponse<string>>('/base/sendVChat', data)

    }

    getMyProfile(data: AuthRequest<MyProfileRequest> = {
        auth: rootStore.mainStore.token,
        data: {
            uid: rootStore.mainStore.uid!
        }
    }) {
        return api.post<any, AxiosResponse<MyProfileResponse>>('/base/getMyProfile', data)
    }

    updateMyProfile(data: AuthRequest<MyProfileUpdateRequest>) {
        return api.post<any, AxiosResponse<MyProfileResponse>>('/base/updateMyProfile', data)
    }

    createInviteRequest(data: AuthRequest<CreateInviteRequest>) {
        return api.post<any, AxiosResponse<CreateInviteResponse>>('/base/createInvite', data)
    }

    checkInviteCode(data: CheckInviteRequest) {
        return api.post<any, AxiosResponse<CheckInviteResponse>>('/base/checkInvite', data)

    }

    deleteProfile(data: AuthRequest<DeleteProfileRequest> = {
        auth: rootStore.mainStore.token,
        data: {
            uid: rootStore.mainStore.uid!
        }
    }) {
        return api.post<any, AxiosResponse<string>>('/base/deleteProfile', data)
    }

    recordVIntroPlay(data: UpdateVIntroVisitRequest) {
        return api.post<any, AxiosResponse<string>>('/base/updateVIntroVisit', data)
    }

    updateGeolocation(data: AuthRequest<UpdateGeolocationRequest>) {
        return api.post<any, AxiosResponse<string>>('/base/updateLocation', data)
    }

    fetchSwipeQueue(data: AuthRequest<FetchDateQueueRequest>) {
        return api.post<any, AxiosResponse<FetchDateQueueResponse>>('/base/fetchDateQueue', data)
    }

    registerLikeAndDump(data: AuthRequest<RegisterLikeAndUnlikeRequest>) {
        return api
            .post<AuthRequest<RegisterLikeAndUnlikeRequest>, AxiosResponse<RegisterLikeAndUnlikeResponse>>('/base/registerLikeAndUnlike', data)
    }

    registerMatch(data: AuthRequest<RegisterMatchRequest>) {
        return api.post<any, AxiosResponse<RegisterMatchResponse>>('/base/registerMatch', data)
    }

    registerDump(data: AuthRequest<RegisterDumpRequest>){
        return api.post<any, AxiosResponse<string>>('/base/registerDump', data)
    }

    getPotMatches(data: AuthRequest<FetchPotMatchesRequest>){
        return api.post<any, AxiosResponse<FetchPotMatchesResp>>('/base/getPotentialMatches', data)
    }

    getNewMatches(data: FetchMatchesRequest){
        return api.post<any, AxiosResponse<FetchMatchesResponse>>('/base/getNewMatches', this.stampAuthRequest(data))
    }

    getConversedMatches(data: FetchConvMatchesRequest){
        return api.post<any, AxiosResponse<FetchConvMatchesResponse>>('/base/getConvMatches', this.stampAuthRequest(data))
    }

    likeOrDump(data: LikeOrDumpRequest){
        return api.post<any, AxiosResponse<LikeOrDumpResponse>>('/base/likeOrDump', this.stampAuthRequest(data))
    }

    updateFcmToken(data: UpdateFcmTokenRequest){
        return api.post<any, AxiosResponse<string>>('/base/updateFcmToken', this.stampAuthRequest(data))
    }

    startHelloConv(data: StartHelloRequest){
        return api.post<any, AxiosResponse<string>>('/base/startHello', this.stampAuthRequest(data))
    }

    getPubKey(data: FetchPubKeyRequest){
        return api.post<any, AxiosResponse<FetchPubKeyResponse>>('/base/getPubKey', this.stampAuthRequest(data))
    }

    sendOfflineMsg(data: OfflineMsg){
        return api.post<any, AxiosResponse<string>>('/base/sendOfflineMsg', this.stampAuthRequest(data))
    }

    blockUser(data: BlockUserRequest){
        return api.post<any, AxiosResponse<string>>('/base/blockUser', this.stampAuthRequest(data))
    }

    fedLogin(data: FedLoginRequest){
        return api.post<any, AxiosResponse<LoginResponse>>('/base/fedLogin', data)
    }

    updateFedEmail(data: UpdateFedEmailRequest){
        return api.post<any, AxiosResponse<UpdateFedEmailResponse>>('/base/updateFedEmail', this.stampAuthRequest(data))
    }

    fetchDumpUsers(data: GetDumpListRequest){
        return api.post<any, AxiosResponse<GetDumpListResponse>>('/base/fetchDumps', this.stampAuthRequest(data))
    }

    revertDumps(data: UpdateDumpsRequest){
        return api.post<any,AxiosResponse<UpdateDumpsResponse> >('/base/revertDumps', this.stampAuthRequest(data) )
    }

    delinkEmail(){
        return api.post<any, AxiosResponse<string>>('/base/delinkEmail', this.stampAuthRequest(null) )
    }

    fetchMatchUser(data: string){
        return api.post<any, AxiosResponse<FetchMatchUserDetailsResponse>>('/base/getMatchUserDetails',this.stampAuthRequest(data) )
    }

    logout(){
        return api.post('/base/logout', this.stampAuthRequest(null) )
    }

    updateDateEnabled(data:boolean){
        return api.post<any, AxiosResponse<string>>('/base/updateDateEnabled', this.stampAuthRequest(data))
    }

    sendAnonMsg(data: OfflineAnonMsg){
        return api.post<any, AxiosResponse<string>>('/base/sendAnonMsg', data)
    }


    private stampAuthRequest<T>(data: T): AuthRequest<T>{
        return {
            auth: rootStore.mainStore.token,
            uid: rootStore.mainStore.uid!,
            data: data
        }
    }

}

export default new ApiService()